<div class="login-wrapper">
  <div class="login-container">
    <form (ngSubmit)="onSubmit()" class="form" [formGroup]="form">
      <h1>Redefinir senha</h1>
      <a>Digite e confirme sua nova senha.</a>
      <div class="form-group">
        <app-input
          type="password"
          label="Senha"
          name="TX_SENH"
          formControlName="TX_SENH"
          maxLength="15"
          [requiredInput]="true"
          (ngModelChange)="confirmacaoSenha()"
          placeholder="Digite aqui"></app-input>

        <app-input
          type="password"
          label="Confirme a senha"
          name="TX_SENH_CNFRM"
          formControlName="TX_SENH_CNFRM"
          maxLength="15"
          [requiredInput]="true"
          (ngModelChange)="confirmacaoSenha()"
          placeholder="Digite aqui"></app-input>

        <div
          class="validators"
          *ngIf="this.form.controls['TX_SENH'].value.length > 0">
          <p [ngClass]="{ valid: isLengthValid, invalid: !isLengthValid }">
            No mínimo 8 caracteres
          </p>
          <p [ngClass]="{ valid: hasNumber, invalid: !hasNumber }">
            Pelo menos um número
          </p>
          <p [ngClass]="{ valid: hasLowercase, invalid: !hasLowercase }">
            No mínimo 1 caractere minúsculo
          </p>
          <p [ngClass]="{ valid: hasUppercase, invalid: !hasUppercase }">
            No mínimo 1 caractere maiúsculo
          </p>
          <p [ngClass]="{ valid: hasSpecialChar, invalid: !hasSpecialChar }">
            No mínimo 1 caractere especial
          </p>
          <p [ngClass]="{ valid: passwordsMatch, invalid: !passwordsMatch }">
            As senhas devem ser iguais
          </p>
        </div>
        <app-botao
          class="button"
          type="primario"
          width="100%"
          [text]="this.title"
          [disabled]="!this.isValid"></app-botao>
      </div>
    </form>
  </div>
  <div class="image-container">
    <img src="assets/LogoLavaLog.svg" />
  </div>
</div>
<app-loader [isLoading]="isLoading"></app-loader>
